import { Goal, Task, TaskType, Timestamp } from '@griply/types';

// the row deadline flag (an action goal's deadline overrides); deadline-tree bucketing uses getEffectiveDeadline
export const getTaskDeadline = (
  task: Task,
  actionGoal: Goal | undefined,
): Timestamp | null => {
  if (actionGoal?.deadline) {
    return actionGoal.deadline;
  }
  if (task.type !== TaskType.Task) {
    return null;
  }
  return task.deadlineDeadline ?? null;
};
